<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

  @if (showHeader && feedbackSurvey.feedbackSurveyText) {
    <div class="tw:w-full tw:px-[15px] tw:mt-6 tw:pl-6 tw:ml-2">
      <label style="font-weight: 500;">{{feedbackSurvey.feedbackSurveyText}}</label>
    </div>
  }

  <div class="tw:w-full tw:px-[15px] tw:mt-4 tw:md:mt-12">

    <div class="tw:w-full tw:px-[15px] tw:mx-auto">

      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:pb-6 tw:content-center tw:justify-center">

        @for (question of feedbackSurvey.feedbackQuestionList; track question) {
          <div class="tw:w-full tw:p-2 tw:m-0 tw:h-full"
            >
            <div class="tw:flex tw:flex-wrap feedback-row tw:pt-4 tw:mx-1 tw:h-full">
              <div class="tw:w-full tw:px-[15px] tw:mb-0 tw:text-center feedback-question-label-container">
                <label class="font-16"> {{question.feedbackQuestionTitle}}</label>
                <br/>
                <label class="font-12"> {{question.feedbackQuestionText}}</label>
              </div>
              <div class="tw:w-full tw:my-0 tw:px-0">
                <div class="tw:flex tw:flex-wrap feedback-icon-master-container tw:mx-auto tw:h-full">
                  @for (answer of question.feedbackAnswerData; track answer; let i = $index) {
                    <div
                      class="tw:flex-1 tw:p-0 tw:m-0 feedback-icon-container tw:text-center"
                      (click)="selectFeedback(question, answer, i)"
                      [ngClass]="{'active': answer.selectedAnswer}">
                      <div class="tw:mx-auto" [ngClass]="answer.calculatedIconClass"></div>
                      <div class="tw:w-full tw:text-center tw:px-2">
                        <label class="feedback-label">{{answer.feedbackAnswerText}}</label>
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (question.showAdditionalQuestions) {
                <div class="tw:flex tw:flex-wrap tw:mx-auto">
                  @for (additionalQuestion of question.feedbackAdditionalQuestionData.followUpQuestionList; track additionalQuestion) {
                    <div class="tw:w-full tw:px-[15px] tw:flex additional-question-separator">
                      <div class="additional-question-text-container">
                        <label class="tw:mr-4 tw:mb-0">{{additionalQuestion.feedbackQuestionTitle}}</label>
                      </div>
                      <div class="tw:flex tw:justify-end tw:content-center tw:grow" >
                        @for (answer of additionalQuestion.feedbackAnswerData; track answer; let j = $index) {
                          <div
                            class="additional-feedback-icon-container"
                            [ngClass]="{'active': answer.selectedAnswer}"
                            (click)="selectAdditionalFeedback(additionalQuestion, j)">
                            <div [ngClass]="answer.calculatedIconClass"></div>
                            {{feedbackAnswerText}}
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (showSubmit) {
          <div class="tw:w-full tw:p-0 tw:m-0">
            <div class="div-flex-buttons tw:justify-center tw:items-center">
              <button mat-button class="btn btn-primary tw:my-1 tw:mx-1"
              (click)="submitFeedback()" [disabled]="disableSubmit">Submit</button>
            </div>
          </div>
        }

      </div>

    </div>

  </div>

</div>